<template>
  <div class="mobile">
    <van-row type="flex">
      <van-col :span="24" class="col">
        <div class="header">
          <div class="language">語言 Language</div>
        </div>
        <div class="select">
          <van-radio-group class="group" v-model="radio">
            <van-radio
              class="group_radio"
              name="chinese"
              checked-color="#666666"
            >
              中文
            </van-radio>
            <van-radio
              class="group_radio"
              name="english"
              checked-color="#666666"
            >
              English
            </van-radio>
          </van-radio-group>
        </div>
        <button @click="goForm()" class="btn">OK</button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: "chinese",
    };
  },
  methods: {
    goForm() {
      if (this.radio === "chinese") {
        this.$router.push({
          path: "/customer/corporate/m/cn",
          name: "CompanyMobileChineseForm",
          params: { language: this.radio },
        });
      } else if (this.radio === "english") {
        this.$router.push({
          path: "/customer/corporate/m/en",
          name: "CompanyMobileEnglishForm",
          params: { language: this.radio },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$bg-color: rgb(22, 155, 213);
body {
  margin: 0;
  padding: 0;
  // background: linear-gradient(to right bottom, lightblue, lightgrey);
}
.mobile {
  width: 100%;
  height: 100vh;
  background: linear-gradient(to right bottom, lightblue, lightgrey);
  display: flex;
  justify-content: center;
  .col {
    width: 72%;
    // height: 38%;
    border-radius: 1%;
    text-align: center;
    position: absolute;
    left: 15%;
    top: 27%;
    box-shadow: 0 0 6px #222222;
    .header {
      width: 90%;
      display: flex;
      line-height: 55px;
      justify-content: space-between;
      margin-left: 5%;
      .language {
        font-size: 1.2rem;
        color: #666;
        font-weight: 600;
      }
    }
    .select {
      width: 100%;
      height: 60px;
      border-top: 1px solid #c0c0c0;
      border-bottom: 1px solid #c0c0c0;
      padding: 10px 0;
      .group {
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        .group_radio {
          font-size: 1.2rem;
          color: #999;
          padding: 0 5%;
        }
      }
    }
    .btn {
      width: 23%;
      background: linear-gradient(to right bottom, lightblue, lightgrey);
      border: 1px solid #777;
      box-shadow: 0 0 5px #444;
      border-radius: 5px;
      text-align: center;
      padding: 4px 6px;
      font-size: 1.3rem;
      color: $bg-color;
      margin: 3% auto;
    }
    .btn:hover {
      cursor: pointer;
    }
  }
}
</style>
